import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetOneAdvertisingAndMediaPlanForTheProject = createAsyncThunk(
  "OneAdvertisingAndMediaPlanForTheProject/OneGetAdvertisingAndMediaPlanForTheProject",
  async (mP_MarketingResourcesAndPublicationsId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/MP_MarketingResourcesAndPublications/GetMP_MarketingResourcesAndPublications",
        {
          mP_MarketingResourcesAndPublicationsId:
            mP_MarketingResourcesAndPublicationsId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "data");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateMP_MarketingResourcesAndPublications = createAsyncThunk(
  "MP_MarketingResourcesAndPublications/ValidatetateApplicationInformationPage",
  async (MarketingResourcesAndPublications, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/MP_MarketingResourcesAndPublications/ValidateMP_MarketingResourcesAndPublications",
        {
          mP_MR_ItemId: MarketingResourcesAndPublications.mP_MR_ItemId,
          itemNameAnother: MarketingResourcesAndPublications.itemNameAnother,
          descriptionContentObjective:
            MarketingResourcesAndPublications.descriptionContentObjective,
          quantity: MarketingResourcesAndPublications.quantity,
          mediaAndAdvertisingPlanExplanation:MarketingResourcesAndPublications.mediaAndAdvertisingPlanExplanation,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const OneAdvertisingAndMediaPlanForTheProject = createSlice({
  name: "OneAdvertisingAndMediaPlanForTheProject",
  initialState: {
    OneAdvertisingAndMediaPlanForTheProject: {},
    loadingOneAdvertisingAndMediaPlanForTheProject: false,
    errorOneAdvertisingAndMediaPlanForTheProject: null,

    OneAdvertisingAndMediaPlanForTheProjectValidate: [],
    loadingOneAdvertisingAndMediaPlanForTheProjectValidate: false,
    errorOneAdvertisingAndMediaPlanForTheProjectValidate: null,
  },
  reducers: {
    restValidationAdvertisingAndMediaPlan:(state,action)=>{
      state.OneAdvertisingAndMediaPlanForTheProjectValidate = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneAdvertisingAndMediaPlanForTheProject.pending,
        (state, action) => {
          state.loadingOneAdvertisingAndMediaPlanForTheProject = true;
          state.OneAdvertisingAndMediaPlanForTheProject = action.payload;
          state.errorOneAdvertisingAndMediaPlanForTheProject = null;
        }
      )
      .addCase(
        GetOneAdvertisingAndMediaPlanForTheProject.fulfilled,
        (state, action) => {
          state.loadingOneAdvertisingAndMediaPlanForTheProject = false;
          state.OneAdvertisingAndMediaPlanForTheProject = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOneAdvertisingAndMediaPlanForTheProject.rejected,
        (state, action) => {
          state.loadingOneAdvertisingAndMediaPlanForTheProject = false;
          state.errorGetOneAdvertisingAndMediaPlanForTheProject =
            action.payload;
        }
      )

      .addCase(
        ValidateMP_MarketingResourcesAndPublications.pending,
        (state, action) => {
          state.loadingOneAdvertisingAndMediaPlanForTheProjectValidate = true;
          state.OneAdvertisingAndMediaPlanForTheProjectValidate =
            action.payload;
          state.errorOneAdvertisingAndMediaPlanForTheProjectValidate = null;
        }
      )
      .addCase(
        ValidateMP_MarketingResourcesAndPublications.fulfilled,
        (state, action) => {
          state.loadingOneAdvertisingAndMediaPlanForTheProjectValidate = false;
          state.OneAdvertisingAndMediaPlanForTheProjectValidate =
            action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateMP_MarketingResourcesAndPublications.rejected,
        (state, action) => {
          state.loadingOneAdvertisingAndMediaPlanForTheProjectValidate = false;
          state.errorOneAdvertisingAndMediaPlanForTheProjectValidate =
            action.payload;
        }
      );
  },
});
export const { restValidationAdvertisingAndMediaPlan } =
  OneAdvertisingAndMediaPlanForTheProject.actions;
export default OneAdvertisingAndMediaPlanForTheProject.reducer;
